import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react'
import API from '../../../utils/API';
import LoadLottie from '../loadLottie';
import Loading from "../../../json/payment-loading.json";
import Tick from "../../../json/tick-mark.json";
import { toast } from 'react-toastify';

export default function SurgeCollegesChecking() {
    const [dataLoaded, setDataLoaded] = useState(false);
    const calledRef = useRef(false);
    const [timeLeft, setTimeLeft] = useState(30)
    const timerRef = useRef(null);

    const handleSubmitPayment = async (payload) => {
        try {

            // --- API Call ---
            const { data } = await axios.post(API.BASE_URL + API.COLLEGE_UPDATE_PAYMENT, {
                officialEmail: payload?.email,
            });
            console.log(data);
            const createTask = await axios.post(API.TASK_BASE_URL + API.CREATE_TASK,
                {
                    projectId: 10070,
                    title: payload?.name,
                    description: JSON.stringify({
                        name: payload?.name,
                        email: payload?.email,
                        number: payload?.number,
                        year: payload?.year,
                        primaryContact: payload?.primaryContact,
                        website: payload?.website,
                        totalCount: payload?.totalCount,
                        location: payload?.location,
                        institutionType: payload?.institutionType,
                        role: payload?.role,
                        stream: payload?.stream,
                        acknowledge: payload?.acknowledge
                    }, null, 2),
                    createdUser: 85155329,
                    assignee: [],
                    stage: "Open",
                    status: "Open",
                    tag: "Open"
                },
                {
                    headers: {
                        form: "bookdemo",
                    },
                });
            console.log(createTask);
        } catch (err) {
            toast.error(err?.response?.data?.error || "Something went wrong. Please try again.", {
                position: "top-right",
                autoClose: 3000,
            });
        }
    };

    useEffect(() => {

        if (calledRef.current) return; // prevent second call
        calledRef.current = true;

        const params = new URLSearchParams(window.location.search);

        const payload = {
            name: params.get("name"),
            email: params.get("email"),
            number: params.get("number"),
            year: params.get("year"),

            primaryContact: params.get("primaryContact"),
            website: params.get("website"),
            totalCount: params.get("totalCount"),
            location: params.get("location"),

            institutionType: params.get("institutionType"),
            role: params.get("role"),
            stream: JSON.parse(params.get("stream") || "[]"), // string → array

            acknowledge: params.get("acknowledge") === "true",
        };

        if (payload.email) {
            handleSubmitPayment(payload);
            setDataLoaded(true);
        }

    }, []);

    useEffect(() => {
        if (dataLoaded) {
            // reset timer every time popup opens
            setTimeLeft(30);

            timerRef.current = setInterval(() => {
                setTimeLeft((prev) => {
                    if (prev <= 1) {
                        clearInterval(timerRef.current);
                        window.location.href = "/"
                        // window.open("https://app.workfast.ai");
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }

        // cleanup when popup closes
        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
                timerRef.current = null;
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataLoaded]);

    return (
        <div className='w-full h-screen bg-[#FFF] max-h-[80vh] rounded-[14px] p-[20px] relative text-center flex flex-col justify-center items-center'>
            {dataLoaded && (
                <div className='font-medium text-[16px] md:text-[22px]'>
                    <p className='text-[#414141] text-center'>Automatically closing in</p>
                    <div className='size-[40px] md:size-[50px] mx-auto mt-[4px] md:mt-[7px] rounded-full border-[2px] border-[#34C759] flex justify-center items-center text-[#34C759]'>{timeLeft}</div>
                </div>
            )}
            {dataLoaded ? (
                <div className='mt-[12px] md:mt-[24px]'>
                    <div className='size-[80px] md:size-[120px] mx-auto flex justify-center items-center'>
                        <LoadLottie animationData={Tick} loop={true} />
                    </div>
                    <p className='text-[20px] md:text-[25px] mt-[4px] font-semibold text-[#000000]'>Congratulations your slot is booked successfully</p>
                    <p className='text-[16px] md:text-[22px] mt-[4px] font-medium text-[#828487]'>We sent the details in registered email.</p>
                </div>
            ) : (
                <div className='mt-[12px] md:mt-[24px]'>
                    <div className='size-[80px] md:size-[120px] mx-auto flex justify-center items-center'>
                        <LoadLottie animationData={Loading} loop={true} />
                    </div>
                    <p className='text-[20px] md:text-[25px] mt-[4px] font-semibold text-[#000000]'>Processing your payment</p>
                    <p className='text-[16px] md:text-[22px] mt-[4px] font-medium text-[#828487]'>Please wait a moment. We’re confirming your payment with the bank. This <br /> page will update automatically once we receive the response.</p>
                </div>
            )}
            {dataLoaded && (
                <button className="mt-[12px] md:mt-[24px] w-[250px] h-[45px] md:h-[62px] rounded-[12px] md:rounded-[18px] text-[16px] md:text-[25px] font-semibold bg-[#34C759] text-[#F3F3F3]"
                    onClick={() => {
                        if (timerRef.current) {
                            clearInterval(timerRef.current);
                            timerRef.current = null;
                        }
                        window.location.href = "/"
                        // window.open("https://app.workfast.ai");
                    }}>
                    Back to Home
                </button>
            )}
        </div>
    )
}
